import React from 'react';
import Header, { HeaderLeft, HeaderRight } from '../../layout/Header/Header';
import Button from '../../components/bootstrap/Button';

const SubscriptionHeader = () => {
    return (
        <Header>
            <HeaderLeft>
                <div className='d-flex'>
                    <h5 className='header-welcome'>
                        Welcome to Liiftsocial, Fenil
                    </h5>
                </div>
            </HeaderLeft>
            <HeaderRight>
                <div className='d-flex'>
                    <a href='/'>
                        <Button
                            color='dark'
                            isOutline
                            style={{ marginLeft: '10px' }}>
                            Return to Dashboard
                        </Button>
                    </a>
                </div>
            </HeaderRight>
        </Header>
    );
};

export default SubscriptionHeader;
